import React from "react";
/*import Select from 'react-select';*/
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import DatePicker from "react-datepicker";
import { get } from 'lodash';
import moment from "moment";
/*import Module from '../../../../utils/Render.js';*/
import SelectQuery from "../../../../component/SelectQuery.js";

export default class ModalDueDate extends React.Component {
  constructor(props) {
    super(props);
    this.initialState = {
      startDate: moment().add(1, "d"),
      minDate: moment().add(1, "d"),
      Site: "",
      Location: "",
      maxDate: null,
      ActiveDataModal: null,
      message: "",
      momentessage: "",
      dateDisabled: false,
      currentLocation: null,
      chStartDate: null,
      nextReservation: null,
      MASTER_SITE: null,
      MASTER_LOCATION: null,
      LOCATION_FILTERED: []
    };
    this.state = Object.assign({}, this.initialState);
    this.isSiteSuggested = false;
    this.isNextToMe = false;
    this.isPastRsv = false;
    this.handleChange = this.handleChange.bind(this);
    this.handleMessageChange = this.handleMessageChange.bind(this);
    this.filterSite = this.filterSite.bind(this);
  }

  handleChange(date) {
    this.setState({
      startDate: date
    });
  }

  handleMessageChange(evt) {
    this.setState({
      message: evt.target.value
    });
  }

  handleSiteChange(event) {
    this.setState(
      {
        Site: event,
        clicked: true,
        Location: ""
      },
      () => this._location.reload("", true)
    );
  }

  handleLocationChange(event) {
    this.setState({
      Location: event,
      clicked: true
    });
  }

  getCurrentLocation(val) {
    this.setState({
      currentLocation: {
        latitude: val.coords.latitude,
        longitude: val.coords.longitude
      }
    });
  }

  getLocationBySite(site) {
    return this.state.MASTER_LOCATION.filter((val, key) => {
      return val.Site === site;
    });
  }

  renderDateField(next) {
    if (this.props.nextReservation) {
      return (
        <div className="row">
          <div className="form-group col-sm-6">
            <label htmlFor="">Original Start Date</label>
            <DatePicker
              id="dueDate"
              name="Location"
              className="form-control"
              dateFormat="YYYY-MM-DD"
              selected={moment(next.StartDate)}
              disabled={true}
            />
          </div>
          <div className="form-group col-sm-6">
            <label htmlFor="">Original Finish Date</label>
            <DatePicker
              id="dueDate"
              name="Location"
              className="form-control"
              dateFormat="YYYY-MM-DD"
              selected={moment(next.FinishDate)}
              disabled={true}
            />
          </div>

          <div className="form-group col-sm-6">
            <label htmlFor="">Changed Start Date</label>
            <DatePicker
              id="dueDate"
              name="Location"
              className="form-control"
              dateFormat="YYYY-MM-DD"
              selected={moment()}
              disabled={true}
            />
          </div>
          <div className="form-group col-sm-6">
            <label htmlFor="">Changed Finish Date</label>
            <DatePicker
              id="dueDate"
              name="Location"
              className="form-control"
              dateFormat="YYYY-MM-DD"
              selected={this.state.startDate}
              minDate={moment().add(1, "d")}
              maxDate={this.state.maxDate}
              onChange={this.handleChange}
            />
          </div>
        </div>
      );
    } else {
      const { ConfirmType } = this.state.ActiveDataModal;
      if (ConfirmType === "to_storage" || ConfirmType === "to_maintenance") {
        return null;
      } else {
        return (
          <div className="row">
            <div className="form-group col-sm-12">
              <label htmlFor="">Set Due Date</label>
              <DatePicker
                id="dueDate"
                name="Location"
                className="form-control"
                dateFormat="YYYY-MM-DD"
                selected={this.state.startDate}
                // selected={this.state.ActiveDataModal.ToReservation.FinishDate}
                minDate={this.state.minDate}
                // minDate={moment().add(1,'d')}
                maxDate={this.state.maxDate}
                onChange={this.handleChange}
                disabled={this.state.dateDisabled}
              />
            </div>
          </div>
        );
      }
    }
  }

  generateLabel(list, mapping) {
    try {
      return list.map((val, key) => {
        if (mapping.label === "Username") {
          val.label = val.FirstName + " " + val.LastName;
        } else {
          val.label = val[mapping.label];
        }
        val.value = val[mapping.value];
        return val;
      });
    } catch (error) {
      if (list != null) {
        let val = [];
        val.value = list[mapping.value];
        val.label = list[mapping.label];
        return val;
      }
      return null;
    }
  }

  filterSite(opt, str, val) {
    if (this.isPastRsv && !this.isNextToMe) {
      return opt.filter(opt => opt.Category !== null);
    }
    return opt;
  }

  willMount() {
    let maxDayAsset = this.props.activeDataModal.Asset.MaxDays;
    let maxDay = moment().add(maxDayAsset, "d");
    let newState = {};
    const { NextReservation } = this.props.activeDataModal;

    newState = {
      maxDate: maxDay
    };

    // if (ToReservation !== null){
    // 	newState = {
    // 		...newState,
    // 		startDate: moment(ToReservation.FinishDate),
    // 		dateDisabled: true,
    // 		Site: ToReservation.Site,
    // 		Location: ToReservation.Location
    // 	};
    // }else{
    if (this.props.nextReservation) {
      const oriStartDate = moment(NextReservation.StartDate);
      const oriFinishDate = moment(NextReservation.FinishDate);
      const maxDate = maxDay < oriFinishDate ? maxDay : oriFinishDate;
      let startDate = moment().add(
        ((oriFinishDate - oriStartDate) / 1000 + 1) / 86400,
        "d"
      );
      startDate = startDate > maxDate ? maxDate : startDate;

      newState = {
        ...newState,
        startDate,
        chStartDate: moment(),
        maxDate: maxDate,
        dateDisabled: true,
        nextReservation: NextReservation.Alias,
        Site: NextReservation.Site,
        Location: NextReservation.Location
      };
    } /*else if(NextReservation){*/
    // 	const nextDate = moment(NextReservation.StartDate);
    // 	this.isNextToMe = NextReservation.User.Username === this.props.UserReducer.username;
    // 	this.isPastRsv = nextDate.isSameOrBefore(moment());
    // 	if(maxDay < nextDate){
    // 		newState.maxDate = maxDay;
    // 	}else{
    // 		newState.maxDate = nextDate;
    // 	}
    // 	newState = {
    // 		...newState,
    // 		dateDisabled: false,
    // 		startDate: moment().add(1,'d')
    // 	}
    // }
    // 	}
    this.setState(newState);
  }

  willUnMount() {
    this.props.onClose();
    this.setState(this.initialState);
    this.isNextToMe = false;
    this.isPastRsv = false;
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.activeDataModal !== null) {
      if (nextProps.activeDataModal.hasOwnProperty("Asset")) {
        nextState.ActiveDataModal = nextProps.activeDataModal;
      }
      return true;
    }
    return false;
  }

  renderField(type) {
    const { selectedItem } = this.props;
    let element = [];

    if (get(selectedItem, 'length', 0) > 0) {
      for (let i = 0; i < selectedItem.length; i++) {
        if (type === "asset") {
          element.push(
            <div
              className="bulk-item-in-modal"
              style={{ marginBottom: "-1rem" }}
              key={selectedItem[i].Asset.Alias}
            >
              <input
                type="text"
                className="form-control"
                style={{ backgroundColor: "#ebebeb", cursor: "default" }}
                value={"Asset : " + selectedItem[i].Asset.Name}
                readOnly
              />
              <input
                type="text"
                className="form-control"
                style={{ backgroundColor: "#ebebeb", cursor: "default" }}
                value={"From : " + selectedItem[i].Accessed.CreatedBy}
                readOnly
              />
              <div className="bulk-item-in-modal-box-remove">
                <button
                  title="Remove selected bulk"
                  onClick={() =>
                    this.props.removeBulkFromModal(selectedItem[i].Alias)
                  }
                  className="bulk-item-in-modal-remove btn-sm btn btn-danger "
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
            </div>
          );
        }
      }
    } else {
      if (type === "asset") {
        element = (
          <input
            type="text"
            className="form-control"
            value={this.state.ActiveDataModal.Asset.Name}
            readOnly
          />
        );
      } else if (type === "from") {
        element = (
          <input
            type="text"
            className="form-control"
            value={this.state.ActiveDataModal.Accessed.CreatedBy}
            readOnly
          />
        );
      }
    }
    return element;
  }

  render() {
    const { selectedItem } = this.props;
    if (this.state.ActiveDataModal === null) {
      return null;
    }

    let ok_text,
      title_text,
      asset_text = null;
    if (get(selectedItem, 'length', 0) > 0) {
      title_text = "Bulk Accept Reasign";
      ok_text = `Accept ${selectedItem.length} assets`;
      asset_text = "List of assets";
    } else {
      title_text = "Accept Reasign";
      ok_text = "Accept";
      asset_text = "Asset";
    }

    return (
      <Modal
        isOpen={this.props.isOpen}
        onEnter={() => this.willMount()}
        onExit={() => this.willUnMount()}
        toggle={() => this.props.toogleModalDueDate(this.state.ActiveDataModal)}
      >
        <ModalHeader
          toggle={() =>
            this.props.toogleModalDueDate(this.state.ActiveDataModal)
          }
        >
          {title_text}
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="form-group col-sm-12">
              <label>{asset_text}</label>
              {this.renderField("asset")}
            </div>
            {get(selectedItem, 'length', 0) <= 0 && (
              <div className="form-group col-sm-12">
                <label>From</label>
                {this.renderField("from")}
              </div>
            )}
            <div className="form-group col-sm-6">
              <label>Site</label>
              <SelectQuery
                name="Site"
                placeholder="Type Site"
                value={this.state.Site}
                urlKey="read-site-autocomplete"
                valKey="Alias"
                valLabel="Name"
                // filterOptions={this.filterSite}
                onChange={val => this.handleSiteChange(val)}
                initOption={this.state.Site}
                UserReducer={this.props.UserReducer}
                disabled={this.state.dateDisabled}
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Location</label>
              <SelectQuery
                name="Location"
                placeholder="Type Location"
                value={this.state.Location}
                urlKey="read-location-autocomplete"
                valKey="Alias"
                valLabel="Name"
                extra={
                  "site=" +
                  (this.state.Site != null ? this.state.Site.value : "")
                }
                initOption={this.state.Location}
                onRef={asd => (this._location = asd)}
                onChange={val => this.handleLocationChange(val)}
                UserReducer={this.props.UserReducer}
                disabled={this.state.dateDisabled}
              />
            </div>
          </div>
          {this.renderDateField(this.state.ActiveDataModal.NextReservation)}
          <div className="row">
            <div className="form-group col-sm-12">
              <label>Message</label>
              <textarea
                name="Message"
                rows="5"
                className="form-control"
                placeholder="Enter Message Here"
                value={this.state.message}
                onChange={this.handleMessageChange}
              ></textarea>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={e =>
              this.props.toogleModalDueDate(this.state.ActiveDataModal)
            }
          >
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={e => this.props.confirmationAnswer("accept", this.state)}
          >
            {ok_text}
          </Button>{" "}
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/home/helper/component/Modal/ModalDueDate.js